import { RichTextRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasRichTextPicker } from "../constants";

import { DefaultCanvasRichTextPicker } from "./richtext-picker";

let loadRichtextPick = !1;

export function bindRichtextCanvasPickerContribution(container) {
    loadRichtextPick || (loadRichtextPick = !0, container.bind(CanvasRichTextPicker).toDynamicValue((() => new DefaultCanvasRichTextPicker(resolveContainerBinding(container, RichTextRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasRichTextPicker));
}
//# sourceMappingURL=richtext-module.js.map
